import validator from 'validator'
import { z } from 'zod'

const PayrollCycleEnum = z.enum(['12', '24', '26', '52'])

const SalesContactSchema = z
  .object({
    fullName: z.string().optional(),
    title: z.string().optional(),
    phone: z
      .string()
      // RHFMobileInput without shouldAllowEmpty stores "+1" for an empty US
      // field. Treat bare country-code-only values as absent so the optional
      // field doesn't block submission when no phone was entered.
      .transform((val) => (/^\+\d{1,3}$/.test(val ?? '') ? '' : val))
      .refine((val) => !val || validator.isMobilePhone(val, 'en-US'), {
        message: 'Please enter a valid phone number',
      })
      .optional(),
    email: z
      .string()
      .refine((val) => !val || validator.isEmail(val), {
        message: 'Please enter a valid email',
      })
      .optional(),
  })
  .optional()

const DateFieldSchema = (label: string) =>
  z
    .string({
      required_error: `${label} is required`,
      invalid_type_error: `${label} is required`,
    })
    .regex(/^\d{4}-\d{2}-\d{2}$/, `${label} is required`)

export const DemoCustomerCreateSchema = z.object({
  companyName: z.string().min(1, 'Company name is required'),
  payrollCycle: PayrollCycleEnum.default('12'),
  salesContact: SalesContactSchema,
  benefitEffectiveDate: DateFieldSchema('Benefit effective date'),
  enrollmentStartDate: DateFieldSchema('Enrollment start date'),
  enrollmentEndDate: DateFieldSchema('Enrollment end date'),
})

export type DemoCustomerCreateFormData = z.infer<
  typeof DemoCustomerCreateSchema
>

// Aliases used by existing callers — kept so imports don't break.
export const DemoCustomerStep1Schema = DemoCustomerCreateSchema
export type DemoCustomerStep1Data = DemoCustomerCreateFormData
